import Parse from 'parse';

import ObjectStore from './object-store';

export function archive(obj) {
    if (obj.className === 'Assignment') {
      obj.get('tasks').forEach(task => {
        task.set('archived', 1);
      });

      if (obj.get('alarm') !== null && obj.get('alarm') !== undefined) {
        obj.get('alarm').set('archived', 1);
      }

      obj.unset('course');
      
      obj.set('archived', 1);

      return obj.save();
    } else if (obj.className === 'Alarm') {
      obj.set('archived', 1);

      return obj.save();
    } else if (obj.className === 'Tag') {
      const tag = obj;

      const Assignment = Parse.Object.extend('Assignment');

      const query = new Parse.Query(Assignment);
      query.equalTo("tags", obj);

      query.find().then(
        function(results) {
          results.forEach((a) => {
            a.relation('tags').remove(tag);
          });

          return Parse.Object.saveAll(results);
        }
      ).then(
        function(result) {
          tag.set('archived', 1);
          return tag.save();
        },
        function(err) {
          console.log("Failed to save Assignments related to Tag: " + JSON.stringify(err));
        }
      );
    }

  }

  export function findAssignmentsByCourse(course, options) {
    const Assignment = Parse.Object.extend('Assignment');
    const query = new Parse.Query(Assignment);

    query.equalTo('course', course);
    query.equalTo('archived', 0);
    query.ascending('dueAt');
    query.include('alarm');
    query.include('grade');
    query.include('tasks');

    query.find({
      success: options.success,
      error: options.error
    });
  }

  export function findAssignmentsDueInRange(start, end, options) {
    const Assignment = Parse.Object.extend('Assignment');
    const query = new Parse.Query(Assignment);

    query.equalTo('archived', 0);
    query.ascending('dueAt');
    query.include('course');
    query.include('alarm');
    query.include('grade');
    query.include('tasks');
    query.greaterThanOrEqualTo('dueAt', start);
    query.lessThan('dueAt', end);

    query.find({
      success: function(results) {
        options.success(results);
      },
      error: function(err) {
        options.error(err);
      }
    });
  }

  export function findAssignmentsPlannedInRange(start, end, options) {
    var Assignment = Parse.Object.extend('Assignment');
    
    var earlierThanTodayQuery = new Parse.Query(Assignment);
    earlierThanTodayQuery.lessThan('plannedAt', new Date())

    var inRangeQuery = new Parse.Query(Assignment);
    inRangeQuery.lessThan('plannedAt', start);
    inRangeQuery.greaterThanOrEqualTo('plannedAt', end);
    
    var query = Parse.Query.or(earlierThanTodayQuery, inRangeQuery)
    query.equalTo('archived', 0);
    query.equalTo('completed', 0);
    query.ascending('dueAt');
    query.include('course');
    query.include('alarm'); 
    query.include('grade');
    query.include('tasks');   
    
    query.find({
      success: options.success,
      error: options.error,
    });
  }

  export function findCourses(opts) {
    var Course = Parse.Object.extend('Course');

    var query = new Parse.Query(Course);
    query.equalTo('archived', 0);
    query.ascending('title');

    if (opts !== undefined) {
      query.find({
        success: opts.success,
        error: opts.error
      });
    } else {
      return query.find();
    }
  }

  export function findInstructors(options) {
    var Instructor = Parse.Object.extend("Instructor");
    
    var query = new Parse.Query(Instructor);
    query.equalTo("archived", 0);
    query.ascending("fullName");
    query.include("avatar");
    query.find({
      success: options.success,
      error: options.error,
    });
  }

  export function findInstructorsByCourse(course, options) {
    var relation = course.relation('instructors');
    var query = relation.query();
    query.ascending("fullName");
    query.include("avatar");
    query.find({
      success: options.success,
      error: options.error,
    });
  }

  export function findCalendarInfos(options) {
    var CalendarInfo = Parse.Object.extend("CalendarInfo");

    var query = new Parse.Query(CalendarInfo);
    query.find({
      success: options.success,
      error: options.error,
    });
  }

  export function findSemesters() {
    var Semester = Parse.Object.extend("Semester");
    var query = new Parse.Query(Semester);
    query.equalTo("archived", 0);
    query.descending("startDate");

    return query.find();
  }

  export function findTags(opts) {
    var Tag = Parse.Object.extend("Tag");

    var query = new Parse.Query(Tag);
    query.equalTo('archived', 0);
    query.ascending('text');

    if (opts !== undefined) {
      query.find({
        success: opts.success,
        error: opts.error,
      });
    } else {
      return query.find();
    }
  }

  export function toggleAssignmentProgress(a) {
    const completed = 1 - a.get('completed');
    a.set('completed', completed);

    if (completed) {
      a.set('completedAt', new Date());

      var grade = a.get('grade');
      if (grade === null || grade === undefined) {
        grade = ObjectStore.buildGrade();
        a.set('grade', grade);
      }

      grade.set('totalPoints', 0);
      grade.set('earnedPoints', 0);

      const alarm = a.get('alarm');
      if (alarm !== null && alarm !== undefined) {
        a.unset('alarm');

        return archive(alarm).then(
          function(obj) {
            return a.save();
          },
          function(err) {
            return new Parse.Promise.error(err.message());
          });
      } else {
        return a.save();
      }
    } else {
      a.unset('completedAt');

      return a.save();
    }
  }

// export default { archive, 
//                  findAssignmentsByCourse, 
//                  findAssignmentsPlannedInRange, 
//                  findCourses, 
//                  findInstructors,
//                  findInstructorsByCourse,
//                  findCalendarInfos,
//                  toggleAssignmentProgress,
//                 }


// WEBPACK FOOTER //
// ./src/services/parse.js